import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {DetailValue, ActionsRow, Icon, FixedDropDownButton, modal} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, DropdownItem, Row} from "reactstrap";
import * as subjektActions from "../actions/subjektActions";
import * as opravneniActions from "../actions/opravneniActions";
import * as adresaFormatter from "../utils/adresaFormatter";
import AdresaForm from "../forms/AdresaForm";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import UzivatelForm from "../forms/UzivatelForm";
import {getUplnaAdresa} from "../utils/adresaFormatter";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující údaje právě přihlášeného uživatele.
 */
class MujUcetPanel extends Component<WithTranslation> {

    static propTypes = {
        uzivatel: PropTypes.object.isRequired, // VO uživatele
        aktivniSpolecnostId: PropTypes.number, // ID právě aktivní společnosti, pokud uživatel nějakou má
        adresyUzivatelList: PropTypes.array.isRequired, // seznam adres uživatele
        spolecnostiUzivatelList: PropTypes.array.isRequired, // seznam společností uživatele
        externiRezim: PropTypes.bool, // zda je aplikace v režimu externího systému, implicitně false
    };

    static defaultProps = {
        externiRezim: false,
    };

    handleEditUdaje = () => {
        const {uzivatel, externiRezim, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            UzivatelForm,
            {
                onSubmit: (data) => {
                    if (data.pobockaVydejVychozi) {
                        data = {...data, pobockaVydejVychozi: {id: data.pobockaVydejVychozi.id}};
                    }
                    if (externiRezim) {
                        const {id, zpusobDopravaVychozi, zpusobPlatbaVychozi, notifikaceSms, notifikaceEmail, pobockaVydejVychozi} = data;
                        const predvolbyVO = {id, zpusobDopravaVychozi, zpusobPlatbaVychozi, notifikaceSms, notifikaceEmail, pobockaVydejVychozi};
                        return SubjektApi.updateUzivatelPredvolby(predvolbyVO, data.id);
                    } else {
                        return subjektActions.updateUzivatel(data);
                    }
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateUzivatelDetail(uzivatel.id));
                    dispatch(subjektActions.invalidateUzivatelVychoziHodnotyDetail(uzivatel.id, null));
                    dispatch(opravneniActions.invalidateLoggedInUser());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: uzivatel,
                showPredvolby: true,
            },
            t('basic_details.edit'),
            {size: "md"}
        ));
    };

    handleNovaAdresa = () => {
        const {uzivatel, aktivniSpolecnostId, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            AdresaForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.createAdresaUzivatel(data, uzivatel.id, aktivniSpolecnostId);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateAktivniAdresyUzivatel(uzivatel.id));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                showNeaktivni: false, // vlastní adresu můžu nastavit jako neaktivní pouze přes samostatnou akci "Smazat"
                showFakturacni: !aktivniSpolecnostId // pokud vystupuji za společnost, nemůžu si určit fakturační adresu
            },
            t('address.new'),
            {size: "md"}
        ));
    };

    handleEditAdresa = (adresa) => {
        const {uzivatel, aktivniSpolecnostId, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            AdresaForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.updateAdresaUzivatel(data, uzivatel.id, data.id, aktivniSpolecnostId);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateAktivniAdresyUzivatel(uzivatel.id));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: adresa,
                showNeaktivni: false,
                showFakturacni: !aktivniSpolecnostId // pokud vystupuji za společnost, nemůžu si určit fakturační adresu
            },
            t('address.edit'),
            {size: "md"}
        ));
    };

    handleDeleteAdresa = (adresa) => {
        const {aktivniSpolecnostId, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('address.delete'),
                t('address.delete_confirm', {address: getUplnaAdresa(adresa)}),
                () => {
                    const {uzivatel} = this.props;
                    const novaAdresa = {...adresa};
                    novaAdresa.neaktivni = true;
                    SubjektApi.updateAdresaUzivatel(novaAdresa, uzivatel.id, novaAdresa.id, aktivniSpolecnostId).then(() => {
                        this.props.dispatch(subjektActions.invalidateAktivniAdresyUzivatel(uzivatel.id));
                    });
                },
                null,
                t('delete')
            )
        );
    };

    handleNastavFakturacni = (adresa) => {
        const {uzivatel, aktivniSpolecnostId} = this.props;
        const novaAdresa = {...adresa};
        novaAdresa.fakturacni = true;
        if (adresa.spolecnost) {
            SubjektApi.updateAdresaSpolecnost(novaAdresa, adresa.spolecnost.id, novaAdresa.id).then(() => {
                this.props.dispatch(subjektActions.invalidateAktivniAdresyUzivatel(uzivatel.id));
            });
        } else {
            SubjektApi.updateAdresaUzivatel(novaAdresa, uzivatel.id, novaAdresa.id, aktivniSpolecnostId).then(() => {
                this.props.dispatch(subjektActions.invalidateAktivniAdresyUzivatel(uzivatel.id));
            });
        }

    };

    handleNastavVychozi = (adresa) => {
        const {uzivatel, aktivniSpolecnostId} = this.props;
        SubjektApi.setAdresaVychozi(uzivatel.id, adresa.id, aktivniSpolecnostId).then(() => {
            this.props.dispatch(subjektActions.invalidateAktivniAdresyUzivatel(uzivatel.id));
        });
    };

    renderSpolecnost = (spolecnost) => {
        const {aktivniSpolecnostId, spolecnostiUzivatelList, t} = this.props;
        let content;
        if (spolecnostiUzivatelList.length > 1 && aktivniSpolecnostId && spolecnost.id === aktivniSpolecnostId) {
            content = <span><b>{spolecnost.nazevSpolecnost}</b> <span className="muted">({t('active').toLowerCase()})</span></span>;
        } else {
            content = <span>{spolecnost.nazevSpolecnost}</span>;
        }
        return <CardBody key={spolecnost.id}>
            {content}
        </CardBody>;
    };

    renderAdresa = (adresa) => {
        const {t} = this.props;
        return <CardBody key={adresa.id}>
            <ActionsRow actions={<FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
                {adresa.lzeEditovat && <DropdownItem key="0" onClick={this.handleEditAdresa.bind(this, adresa)}>{t('edit')}</DropdownItem>}
                <DropdownItem key="1" onClick={this.handleNastavVychozi.bind(this, adresa)}>{t('set_as_default')}</DropdownItem>
                {adresa.lzeNastavitFakturacni && <DropdownItem key="2" onClick={this.handleNastavFakturacni.bind(this, adresa)}>{t('set_as_billing')}</DropdownItem>}
                {adresa.lzeEditovat && <DropdownItem key="3" onClick={this.handleDeleteAdresa.bind(this, adresa)}>{t('delete')}</DropdownItem>}
            </FixedDropDownButton>}>
            {adresaFormatter.getUplnaAdresa(adresa)}
            {adresa.vychozi && <i className="muted"> ({t('default').toLowerCase()}) </i>}
            {adresa.fakturacni && <i className="muted"> ({t('billing').toLowerCase()}) </i>}
        </ActionsRow>
        </CardBody>;
    };

    render() {
        const {uzivatel, adresyUzivatelList, spolecnostiUzivatelList, t} = this.props;

        const fakturacniAdresy = adresyUzivatelList.filter(adresa => adresa.fakturacni);

        return <Card className="h-100">
            <CardHeader>
                <ActionsRow actions={
                    <ButtonToolbar>
                        <Button type="button" onClick={this.handleEditUdaje}>{t('edit')}</Button>
                    </ButtonToolbar>
                }>
                    <h2>{t('my_account')}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody>
                <h2><b>{t('contact_and_billing_information')}</b></h2>
                <Row>
                    <Col md={4}>
                        <DetailValue label={t('firstname_and_surname')}>{uzivatel.zobrazJmeno}</DetailValue>
                    </Col>
                    <Col md={4}>
                        <DetailValue label={t('email')}>{uzivatel.email}</DetailValue>
                    </Col>
                    <Col md={4}>
                        <DetailValue label={t('phone')}>{uzivatel.telefon}</DetailValue>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <DetailValue label={t('address.title_one')}>{fakturacniAdresy.length > 0 ? adresaFormatter.getUplnaAdresa(fakturacniAdresy[0]) : <i className="muted">{t('address.no_billing_address_defined')}</i>}</DetailValue>
                    </Col>
                </Row>
                <Row>
                    <Col className="mt-3 mb-3">
                        <h2><b>{t('companies')}</b></h2>
                        {spolecnostiUzivatelList.length > 0 ? spolecnostiUzivatelList.map(this.renderSpolecnost) : <i className="muted">{t('account_no_company')}</i>}
                    </Col>
                </Row>
                <Row>
                    <Col className="mt-3 mb-3 items-list">
                        <ActionsRow actions={<ButtonToolbar>
                            <Button type="button" onClick={this.handleNovaAdresa}>{t('new_f')}</Button>
                        </ButtonToolbar>}>
                            <h2><b>{t('address.title_many')}</b></h2>
                        </ActionsRow>
                        {adresyUzivatelList.length > 0 ? adresyUzivatelList.map(this.renderAdresa) : <i className="muted">{t('address.no_addresses_defined')}</i>}
                    </Col>
                </Row>
            </CardBody>
        </Card>
    }
}

export default connect()(withTranslation()(MujUcetPanel));
